Controller.$inject = [];

function Controller() {
    const self = this;
    
    self.$onInit = function() {
    };
    
    self.getShowCloseIcon = function() {
        return self.popoverCtrl ? self.popoverCtrl.showCloseIcon : true;
    };
    
    self.close = function() {
        if (self.popoverCtrl?.close) {
            self.popoverCtrl.close();
        } else {
            console.log('Parent popover controller not found or close method not available');
        }
    };
}

export function HuiPopoverHeader() {
    return {
        restrict: 'E',
        scope: {},
        require: {
            popoverCtrl: '^^huiPopover'
        },
        bindToController: {},
        controller: Controller,
        controllerAs: '$huiPopoverHeaderCtrl',
        transclude: true,
        template: `
            <div class="hui-popover-header">
                <div class="header-content">
                    <ng-transclude></ng-transclude>
                </div>
                <button ng-if="$huiPopoverHeaderCtrl.getShowCloseIcon()" 
                        class="hui-close-button" 
                        ng-click="$huiPopoverHeaderCtrl.close()"
                        aria-label="Close popover"
                        type="button">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        `
    };
} 